import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebaseConfig";
import { User } from "lucide-react";
import MyAccountProfileDrawer from "./MyAccountProfileDrawer";
import AppDrawer from "./ui/AppDrawer";
import { getAvatarUrl } from "../utils/avatar";
import ro from "/src/content/ro.json";

const MobileNavDrawer = ({
  open,
  onClose,
  navLinks,
  currentUser,
  onProfileClick,
}) => {
  const [user, setUser] = useState(null);
  const [profileOpen, setProfileOpen] = useState(false);

  const avatarUrl = getAvatarUrl({
    photoURL: currentUser?.photoURL || currentUser?.providerData?.[0]?.photoURL,
    email: currentUser?.email,
    name: currentUser?.displayName,
  });

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => setUser(u || null));
    return () => unsub();
  }, []);

  return (
    <>
      <AppDrawer
        open={open}
        onClose={onClose}
        title={ro.nav.mobile.title}
        className="md:hidden mobile-nav-drawer"
        footer={
          !user ? (
            <div className="drawer-actions">
              <Link to="/login" onClick={onClose} className="drawer-cta primary">
                {ro.nav.mobile.login}
              </Link>
              <Link
                to="/register"
                onClick={onClose}
                className="drawer-cta primary"
              >
                {ro.nav.mobile.register}
              </Link>
            </div>
          ) : (
            <button
              onClick={() => setProfileOpen(true)}
              className="drawer-cta primary"
            >
              {ro.nav.mobile.viewProfile}
            </button>
          )
        }
      >
        <div className="drawer-card drawer-profile">
          <div className="drawer-avatar">
            {currentUser ? (
              <img
                src={avatarUrl}
                className="w-full h-full object-cover"
                alt={ro.nav.mobile.avatarAlt}
                onError={(e) => (e.target.src = "/images/imgaine1.svg")}
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center">
                <User size={28} className="text-orange-500" />
              </div>
            )}
          </div>
          <div>
            <p className="drawer-name">
              {currentUser?.displayName || ro.nav.mobile.welcome}
            </p>
            <p className="drawer-sub">
              {currentUser?.email || ro.nav.mobile.loginHint}
            </p>
          </div>
        </div>

        <div className="drawer-section">
          <p className="drawer-section-title">{ro.nav.mobile.sectionTitle}</p>
          <div className="drawer-nav">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={onClose}
                className="drawer-link"
              >
                {link.title}
              </a>
            ))}
          </div>
        </div>
      </AppDrawer>

      {user && (
        <MyAccountProfileDrawer
          open={profileOpen}
          onClose={() => setProfileOpen(false)}
        />
      )}
    </>
  );
};

export { MobileNavDrawer };
export default MobileNavDrawer;
